import { useApi } from '@/api';
import { KpiCard } from '@/components';
import { tokensMapping } from '@/utils/tokens';
import { Flex, KpiSkeleton } from '@blockanalitica/ui';

export default function KPIs() {
  const [data, error] = useApi({
    url: `/tokens/0xdc035d45d973e3ec169d2276ddab16f1e407384f/holders/0x1e1D42781FC170EF9da004Fb735f56F0276d01B8/`
  });

  if (error) {
    throw error;
  }
  if (data) {
    const variant = 'usds';

    return (
      <Flex gap={['m', 's']} flexDirection={['column', 'row']}>
        <KpiCard
          title="Total bridged to Solana"
          data={data}
          variant={variant}
          field="balance"
          options={{
            currency: tokensMapping('USDS')
          }}
        />
      </Flex>
    );
  }
  return <KpiSkeleton />;
}
